'use client';

import { signIn } from '@lichtblick/auth';
import { Button } from '@lichtblick/ui-components';

export const LoginButton = ({ label }: { label: string }) => (
  <Button isParentSize label={label} onClick={() => signIn('keycloak')} />
);
